<app-header-tela [titulo]="'Suporte'" [exibirFechar]="true" (fechou)="fecheTela()"></app-header-tela>

<div class="container p-2 avaliar-suporte">
  <div class="estado" *ngIf="carregando">
    Carregando avaliação...
  </div>

  <div class="alert alert-danger mt-2" role="alert" *ngIf="msgErro">
    {{msgErro}}
  </div>

  <ng-container *ngIf="!carregando && avaliacao">
    <h3>Avalie o atendimento</h3>
    <p class="text-muted mb-1">
      Ticket #{{avaliacao.ticketId}} - {{avaliacao.empresaNome}}
    </p>
    <h5>{{avaliacao.ticketTitulo}}</h5>

    <div class="agradecimento" *ngIf="enviado">
      <i class="fas fa-check-circle"></i>
      <h4>Obrigado pela avaliação!</h4>
      <p>Sua resposta ajuda a melhorar nosso suporte.</p>
    </div>

    <div *ngIf="!enviado">
      <div class="pt-2">
        <h4 class="mb-0">Como foi o atendimento?</h4>
        <span>
          <span *ngFor="let star of [1, 2, 3, 4, 5]"
                class="star"
                [class.filled]="star - 1 < resposta.nota"
                [class.bad]="resposta.nota > 0 && resposta.nota <= 3"
                (click)="resposta.nota = star; msgErro = ''"
                (keydown.enter)="resposta.nota = star; msgErro = ''"
                tabindex="0"
                role="button">&#9733;</span>
        </span>
      </div>

      <div class="pt-2">
        <h4>O problema foi resolvido?</h4>
        <hr class="mt-1 mb-1">
        <input type="radio"
               id="suporteResolvidoSim"
               name="resolveuProblema"
               [(ngModel)]="resposta.resolveuProblema"
               kendoRadioButton
               [value]="true" />
        <kendo-label class="k-radio-label"
                     for="suporteResolvidoSim"
                     text="Sim, foi resolvido"></kendo-label>

        <hr class="mt-1 mb-1">
        <input type="radio"
               id="suporteResolvidoNao"
               name="resolveuProblema"
               [(ngModel)]="resposta.resolveuProblema"
               kendoRadioButton
               [value]="false" />
        <kendo-label class="k-radio-label"
                     for="suporteResolvidoNao"
                     text="Não, ainda preciso de ajuda"></kendo-label>
      </div>

      <div class="pt-3">
        <kendo-label><i class="fas fa-comment-alt"></i> Deixar comentário</kendo-label>
        <textarea maxlength="1000"
                  [style.width]="'100%'"
                  class="form-control mt-1"
                  [(ngModel)]="resposta.comentario"></textarea>
      </div>

      <div class="pt-3">
        <button class="btn btn-block btn-primary p-2"
                (click)="enviarAvaliacao()"
                [disabled]="enviando">
          Enviar avaliação
        </button>
      </div>
    </div>
  </ng-container>
</div>
